import {Map} from 'immutable';

import FillInTheBlankEditor from './FillInTheBlankEditor';
import FillInTheBlankQuestionV2 from './V2/FillInTheBlankQuestion';
import FillInTheBlankExplanationArea from './V2/FillInTheBlankExplanation';
import FillInTheBlankResponseStats from './V2/FillInTheBlankResponseStats';

export const FillInTheBlankQuestionType = Map({
  type: 'fill-in-the-blank',
  label: 'Fill In the Blank',
  questionRenderer: FillInTheBlankQuestionV2,
  explanationRenderer: FillInTheBlankExplanationArea,
  responseStatsRenderer: FillInTheBlankResponseStats,
  editor: FillInTheBlankEditor,
  isHidden: false
});
